import { topics } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-3xl font-heading text-foreground-900 mb-2">
            热门话题
          </h2>
          <p className="text-sm text-foreground-600">当前最受关注的赛事话题，加入讨论</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {topics.map((topic) => (
            <a
              key={topic.id}
              href="#cards"
              className="group flex items-center gap-3 p-3 md:p-4 rounded-xl bg-background-50 hover:bg-background-200/70 transition-colors cursor-pointer"
            >
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  {topic.hot && (
                    <span className="inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded text-[10px] font-medium bg-primary-100 text-primary-700 whitespace-nowrap">
                      <span className="w-3 h-3 flex items-center justify-center">
                        <i className="ri-fire-line text-[10px]"></i>
                      </span>
                      热
                    </span>
                  )}
                  <h3 className="text-sm font-medium text-foreground-900 truncate group-hover:text-primary-500 transition-colors">
                    #{topic.name}
                  </h3>
                </div>
                <p className="text-xs text-foreground-500">{topic.count}</p>
              </div>
              <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 text-foreground-400 group-hover:text-primary-500 transition-colors">
                <i className="ri-arrow-right-s-line"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}